import { FastlyImage } from '@components/common/image'

const STATS = [
  {
    bg: 'bg-yellow-100 border-yellow-200 border',
    content: (
      <>
        <span className="text-orange2-400 font-600">822,228</span> live classes
      </>
    ),
  },
  {
    bg: 'bg-blue-50 border-blue-200 border',
    content: (
      <>
        <span className="text-blue-200 font-600">75.8 million</span> minutes of
        live learning
      </>
    ),
  },
  {
    bg: 'bg-green-50 border-green-100 border',
    content: (
      <>
        Students from <span className="text-green-100 font-600">135</span>{' '}
        countries &amp; <span className="text-green-100 font-600">2019</span>{' '}
        cities
      </>
    ),
  },
]

const ClassroomWorldwide = () => (
  <div className="px-5 py-12 lg:py-16">
    <div className="container mx-auto flex flex-col md:flex-row items-center gap-10">
      {/* Left: globe image */}
      <div className="flex-1 flex justify-center">
        <FastlyImage
          src="/images/teacher-lp/globe.png"
          alt="Codingal penguin on globe"
          width={599}
          height={509}
          className="w-full max-w-sm md:max-w-md"
        />
      </div>

      {/* Right: text + stats */}
      <div className="flex-1 flex flex-col gap-5">
        <h2 className="pb-1 text-2xl text-grey lg:text-4xl font-600 text-center md:text-left">
          Your classroom is worldwide
        </h2>
        <p className="text-lg text-grey leading-relaxed text-center md:text-left">
          Your students will not just come from one city or country. Codingal
          has students across 135 countries, from the United States to India,
          the United Kingdom to the UAE, Singapore to Australia, and beyond.
          This means you experience different cultures, different time zones,
          and different perspectives.
        </p>
        <h3 className="text-lg font-600 text-grey-900 text-center md:text-left">
          In 2025, Codingal teachers delivered:
        </h3>
        <ul className="flex flex-col gap-3 list-none p-0">
          {STATS.map((stat, i) => (
            <li
              key={i}
              className={`${stat.bg} rounded-xl px-6 py-3 text-base font-500 text-grey-900 text-center`}
            >
              {stat.content}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
)

export default ClassroomWorldwide
